<template>
  <v-alert
    icon="mdi-cash-usd-outline"
    text
    :type="'info'"
    style="grid-area: price"
    v-if="!showReanalysisAlert && price !== null"
    outlined
  >
    <span
      >Price: ${{ price }} AUD
      {{ medicare ? "(Provided by Medicare)" : "" }}

      <slot name="funding"></slot>
    </span>
  </v-alert>
</template>

<script>
export default {
  props: {
    price: Number,
    medicare: Boolean,
    showReanalysisAlert: { type: Boolean, default: false },
  },
};
</script>
